import React from "react";
import PurchaseLegalAcknowledgment from "./PurchaseLegalAcknowledgment";
import "./legal-components.css";

/**
 * Transaction-point legal gate for Library card / digital checkouts and wallet rails.
 * Not mounted on general catalog chrome — parents open this only when a purchase is attempted.
 */
export default function LibraryPurchaseLegalModal({
  isOpen,
  onClose,
  purchaseKind,
  showMerchCheckbox,
  legalAck,
  onValidityChange,
  onContinue,
}) {
  if (!isOpen) return null;

  const ready =
    purchaseKind === "nft" ? Boolean(legalAck?.libraryNftOk) : Boolean(legalAck?.libraryDigitalOk);

  return (
    <div
      className="td-lib-legal-modal-root"
      role="dialog"
      aria-modal="true"
      aria-labelledby="td-lib-legal-modal-title"
    >
      <button type="button" className="td-lib-legal-modal-backdrop" onClick={onClose} aria-label="Close" />
      <div className="td-lib-legal-modal">
        <button type="button" className="td-lib-legal-modal__close" onClick={onClose} aria-label="Close dialog">
          ×
        </button>
        <h3 id="td-lib-legal-modal-title" className="td-lib-legal-modal__title">
          Before secure checkout
        </h3>
        <p className="td-lib-legal-modal__subtitle">
          Confirm the instruments that apply for this purchase. You can cancel and keep browsing.
        </p>
        <PurchaseLegalAcknowledgment
          showMerchCheckbox={showMerchCheckbox}
          onValidityChange={onValidityChange}
          className="td-lib-legal-modal__panel"
        />
        <div className="td-lib-legal-modal__actions">
          <button type="button" className="oshar-btn-outline oshar-re-action-btn" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="oshar-btn-gold oshar-re-action-btn" disabled={!ready} onClick={onContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
